import urls from "../../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../../utils/service";

export async function uploadDeveloperImage(body: any,name:any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(`${urls.UPLOADDEVELOPERIMAGE}/${name}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}